import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';
type ArrowBackIosNewProps = IconComponentBaseProps;

export const ArrowBackIosNew = ({
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[7],
  className,
}: ArrowBackIosNewProps) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_7277_5902"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill={fill} />
      </mask>
      <g mask="url(#mask0_7277_5902)">
        <path
          d="M8.81925 12L16.5345 19.7155C16.682 19.8628 16.7548 20.0391 16.753 20.2443C16.751 20.4494 16.6763 20.6257 16.5288 20.773C16.3814 20.9205 16.2052 20.9943 16 20.9943C15.7948 20.9943 15.6186 20.9205 15.4713 20.773L7.82875 13.1365C7.66725 12.975 7.54934 12.7949 7.475 12.5963C7.40067 12.3974 7.3635 12.1987 7.3635 12C7.3635 11.8013 7.40067 11.6026 7.475 11.4038C7.54934 11.2051 7.66725 11.025 7.82875 10.8635L15.4713 3.22125C15.6186 3.07375 15.7958 3.001 16.003 3.003C16.21 3.00483 16.3872 3.0795 16.5345 3.227C16.682 3.37433 16.7558 3.55058 16.7558 3.75575C16.7558 3.96092 16.682 4.13717 16.5345 4.2845L8.81925 12Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
